import { ChannelType } from '@/models/channel.model';

export enum LLMTemplateEndpoints {
  ROOT = '/llm/templates',
}

export const staticLLMTemplateEndpoints = {
  GET_VARIABLES: `${LLMTemplateEndpoints.ROOT}/variables`,
  GET_BASE_TEMPLATES: `${LLMTemplateEndpoints.ROOT}/base`,
};

export const getLLMChannelTemplateEndpoints = ({ channelId }: { channelId: number | string }) => ({
  CHANNEL_TEMPLATE: `${LLMTemplateEndpoints.ROOT}/channel/${channelId}`,
});

export const getLLMBaseTemplateEndpoints = ({ channelType }: { channelType: ChannelType }) => ({
  BASE_TEMPLATE: `${LLMTemplateEndpoints.ROOT}/base/${channelType}`,
});

export enum LLMTemplateSource {
  BASE = 'BASE',
  INDIVIDUAL = 'INDIVIDUAL',
}

export interface IChannelLLMTemplate {
  channelId: number;
  channelType: ChannelType;
  source: LLMTemplateSource;
  templateId: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface ILLMTemplateVariable {
  code: string;
  placeholder: string;
  description: string;
  format: string;
  emptyValueBehavior: string;
}

export interface IBaseLLMTemplate {
  id: string;
  channelType: ChannelType;
  content: string;
  createdAt: string;
  updatedAt: string;
}

// ============== DTO ==============

export interface IGetChannelLLMTemplateDTO {
  channelId: number;
}

export interface IUpdateChannelLLMTemplateDTO {
  channelId: number;
  content: string;
}

export interface IResetChannelLLMTemplateDTO {
  channelId: number;
}

export interface IGetBaseLLMTemplateDTO {
  channelType: ChannelType;
}

export interface IUpdateBaseLLMTemplateDTO {
  channelType: ChannelType;
  content: string;
}

// ============== Response ==============

export type IGetChannelLLMTemplateResponse = IChannelLLMTemplate;

export type IUpdateChannelLLMTemplateResponse = IChannelLLMTemplate;

export type IResetChannelLLMTemplateResponse = IChannelLLMTemplate;

export type IGetLLMTemplateVariablesResponse = ILLMTemplateVariable[];

export type IGetBaseLLMTemplatesResponse = IBaseLLMTemplate[];

export type IGetBaseLLMTemplateResponse = IBaseLLMTemplate;

export type IUpdateBaseLLMTemplateResponse = IBaseLLMTemplate;
